<template>
  <div>
    <div class="row">
      <button
        type="button"
        class="btn btn-outline-primary ml-4 my-1"
        @click="getChart('Basic Healthcare Provision Fund')"
      >
        Basic Healthcare Provision Fund
      </button>

      <button
        type="button"
        class="btn btn-outline-success ml-4 my-1"
        @click="getChart('State Equity Program')"
      >
        State Equity Program
      </button>
    </div>

    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      title: "",
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: "",
      sector: "Basic Healthcare Provision Fund",
      seriesColor: "#6fcd98",
      colorInputIsSupported: null,
      chartOptions: {},
    };
  },
  mounted() {
    this.getDashboardLGA();
  },
  methods: {
    getChart(param) {
      this.isLoading = true;
      this.sector = param;
      this.getDashboardLGA();
      this.isLoading = false;
    },
    getDashboardLGA() {
      this.axios
        .get("/api/v1/auth/enrolleesbylgabyvulnerables/2679", {
          params: {
            sector: this.sector,
          },
        })
        .then((response) => {
          var data = response.data;
          data;
          this.chartOptions = {
            chart: {
              type: "column",
            },
            title: {
              text: "Enrollees by Vulnerable Groups",
            },
            subtitle: {
              text: "Distributed by LGA",
            },
            xAxis: {
              categories: response.data.lgas,
              crosshair: true,
            },
            yAxis: {
              min: 0,
              title: {
                text: "Total Enrollees",
              },
            },
            tooltip: {
              headerFormat:
                '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat:
                '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
              footerFormat: "</table>",
              shared: true,
              useHTML: true,
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
              },
            },
            series: [
              {
                name: "Pregnant Women",
                data: response.data.pregnant,
              },
              {
                name: "Children Under 5",
                data: response.data.children,
              },
              {
                name: "Aged",
                data: response.data.aged,
              },
              {
                name: "Special Needs",
                data: response.data.special,
              },
              {
                name: "Poorest of the Poor",
                data: response.data.poor,
              },
            ],
          };
        });
    },
  },
};
</script>
  
  <style>
</style>
  